import React, { useState } from 'react';
import { Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import ForbiddenPage from "./components/ForbiddenPage";
import Layout from './components/Layout';
import LoginForm from './components/LoginForm';
import './custom.css';
import CookieManager from './CookieManager';

const App = () => {

  const [loginErrorMessage, setLoginErrorMessage] = useState('');

  const location = useLocation();
  const navigate = useNavigate();


  // login reale JWT
  const handleLogin = async (username, password) => {
    try {
      const response = await fetch('auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });

      if (response.ok) {
        setLoginErrorMessage('');
        const data = await response.json();
        CookieManager.set(data);
        const { from } = location.state || { from: { pathname: '/' } };
        navigate(from);
      }
      else {
        setLoginErrorMessage(response.status + ' - ' + response.statusText);
      }
    } catch (error) {
      console.error(error);
    }

  };


  const handleLogout = () => {
    CookieManager.remove();
    navigate('/login');
  };


  return (
    <Layout
      isLoggedIn={CookieManager.isValid()}
      handleLogout={handleLogout}
    >
      <Routes>
        {AppRoutes.map((route) => {
          const { element, path, isPrivate, roles } = route;
          return (
            <Route
              key={path}
              path={path}
              element={
                isPrivate
                  ? <PrivateRoute roles={roles}>{element}</PrivateRoute>
                  : element
              }
            />
          );
        })}
        <Route
          path="/login"
          element={
            <LoginForm
              errorMessage={loginErrorMessage}
              handleLogin={handleLogin}
            />
          }
        />
        <Route path="/logout" element={<Navigate to="/login" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

/*
  NOTE:
  > In React Router v6 NON si wrappa pi� <Route>:

    const PrivateRoute = ({ element, ...rest }) => {
      const isLoggedIn = CookieManager.get();
      return isLoggedIn ? <Route {...rest} element={element} /> : <Navigate to="/login" />;
    };

  si wrappa l'element:
*/

const PrivateRoute = ({ children, roles }) => {

  if (!CookieManager.isValid()) {
    return <Navigate to="/login" replace />;
  }

  if (!roles) {
    return children;
  }

  const authorized = CookieManager.isInRoles(roles);

  if (!authorized) {
    return <ForbiddenPage />;
  }

  return children;

  //return authorized
  //  ? children
  //  : <Navigate to="/login" replace />;

};

export default App;
